import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { KeyRound, Loader2 } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/login", { email, password });
      toast.success("Bienvenido");
      navigate("/admin");
    } catch {
      toast.error("Credenciales incorrectas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-5">
      <Toaster theme="dark" richColors position="top-center" />
      <div className="w-full max-w-md sc-card rounded-md p-8">
        <div className="flex items-center gap-3 mb-7">
          <div className="w-11 h-11 rounded-md bg-[#FFC107] flex items-center justify-center">
            <KeyRound className="w-5 h-5 text-black" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display font-bold text-xl">SasCerrajería</div>
            <div className="text-xs font-mono uppercase tracking-wider text-[#71717A]">Panel de administración</div>
          </div>
        </div>
        <h1 className="font-display font-bold text-3xl mb-2">Acceder</h1>
        <p className="text-sm text-[#A1A1AA] mb-6">Gestiona solicitudes, precios y pagos.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-[#A1A1AA] mb-2 block">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full bg-[#141414] border border-white/10 rounded-md px-4 py-3.5 text-white focus:border-[#FFC107] outline-none"
              data-testid="admin-email" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-[#A1A1AA] mb-2 block">Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full bg-[#141414] border border-white/10 rounded-md px-4 py-3.5 text-white focus:border-[#FFC107] outline-none"
              data-testid="admin-password" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full btn-amber py-3.5 rounded-md font-semibold flex items-center justify-center gap-2"
            data-testid="admin-login-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
          </button>
        </form>
        <p className="text-xs text-[#71717A] mt-6 text-center">Acceso restringido al personal autorizado.</p>
      </div>
    </div>
  );
}
